/* Lettoria ODD LOT SALE — ⚡ "Last in the box" Lightning: one product every 30 s, then it leaves the screen (port of the
 * Skullette Odd Lot module 10-15 — anh 10-16 chose this over the ops brief's scroll-row idea: Skullette ran well with it).
 * Pool = ONLY odd-lot items (tag ol-odd-lot, <10 left each, live qty → "Only N left") still available — never topped up
 * with ol-slow items (ops: no scarcity for slow; "last in the box" would be untrue). When all are gone the block hides.
 * Pool items are NOT on the shelf (LOD.inLightning). Order: price tiers
 * high→low, round-robin, lowest stock first within a tier. slot = floor(now/30s) % N; the pool is re-read on
 * 'lod:data' but the shown item only changes at a slot boundary — unless it sells out: sold out while on screen →
 * GONE + "Next one in m:ss" (if this shopper claimed it, they keep "✓ In your cart"). Needs window.LOD.
 * Copy rule: never say an item "won't come back" (it repeats while it's in stock). */
(function () {
  var A = window.LOD;
  if (!A) return;
  var root = A.root;
  var wrap = root.querySelector('[data-lod-ld-wrap]');
  var box = root.querySelector('[data-lod-ld]');
  if (!wrap || !box) return;
  var SLOT = 30000;
  var POOL = [], IN = {}, claimed = {};
  var shownSlot = null, cur = null; // cur = { it, slot, gone, at }

  function computePool(data) {
    var low = function (d) { return d.q == null ? 999 : d.q; };
    var pool = data.filter(function (d) { return d.s === 'odd' && d.a; }).sort(function (x, y) { return low(x) - low(y); });
    var tiers = {};
    pool.forEach(function (d) { (tiers[d.p] = tiers[d.p] || []).push(d); });
    var keys = Object.keys(tiers).sort(function (a, b) { return b - a; });
    var out = [];
    for (var r = 0; out.length < pool.length; r++) keys.forEach(function (k) { if (tiers[k][r]) out.push(tiers[k][r]); });
    return out;
  }
  function setPool() {
    POOL = computePool(A.data()); IN = {};
    POOL.forEach(function (d) { IN[d.h] = true; });
  }
  A.inLightning = function (h) { return !!IN[h]; };
  setPool();

  function slotNo() { return Math.floor(A.now() / SLOT); }
  function endsAt() { return (slotNo() + 1) * SLOT; }

  function tick() {
    if (A.phase() !== 'live') return;
    wrap.hidden = POOL.length === 0 && !(cur && (cur.gone || claimed[cur.it.h]));
    if (wrap.hidden) return;
    var s = slotNo();
    if (s !== shownSlot && !POOL.length) { cur = null; wrap.hidden = true; return; } // nothing left to rotate
    if (s !== shownSlot) { shownSlot = s; render(POOL[s % POOL.length], s); }
    timers();
  }

  // Intro claims are computed from the live pool so they stay true all day (Afroyla copy, anh-approved 10-14):
  // "1–N left" = the pool's real max qty; "up to N% off" = the pool's real max discount right now.
  // Count claim only when EVERY pooled item has a real tracked qty (q null = untracked → say "a few", never a number).
  function intro() {
    var maxQ = 0, maxOff = 0, known = POOL.length > 0;
    POOL.forEach(function (d) { if (d.q == null) known = false; else maxQ = Math.max(maxQ, d.q); maxOff = Math.max(maxOff, A.pct(d.p, d.c)); });
    var count = !known ? 'Only a few left of each' : maxQ <= 1 ? 'Only 1 left of each' : 'Only 1–' + maxQ + ' left of each';
    return 'The pieces closest to gone. ' + count + (maxOff ? ', up to ' + maxOff + '% off' : '') + ', and a new one every 30 seconds.';
  }

  function render(it, s) {
    cur = { it: it, slot: s, gone: false, at: Date.now() };
    var off = A.pct(it.p, it.c);
    var mine = claimed[it.h];
    var left = it.s === 'odd' && it.q != null && it.q > 0;
    box.innerHTML =
      '<p class="lod-ld__kicker">⚡ Last in the box</p>' +
      '<p class="lod-ld__intro">' + intro() + '</p>' +
      '<ol class="lod-steps"><li><b>1</b>New deal every 30 sec</li>' +
        '<li><b>2</b>Tap <em>Claim</em> before 0:00</li><li><b>3</b>Price held till ' + A.endLabel() + '</li></ol>' +
      '<div class="lod-ld__card">' +
        '<a class="lod-ld__media" href="/products/' + A.esc(it.h) + '" data-lod-quick="' + A.esc(it.h) + '" data-hc-el="lightning-quick-view">' +
          '<img src="' + A.esc(A.img(it.i, 700)) + '" alt="' + A.esc(it.t) + '" width="700" height="933" fetchpriority="high">' +
          (off ? '<span class="lod-badge">−' + off + '%</span>' : '') +
          (left ? '<span class="lod-left-tag">Only ' + it.q + ' left</span>' : '') +
          '<span class="lod-gone-stamp" aria-hidden="true">GONE</span></a>' +
        '<div class="lod-ld__info">' +
          '<h3 class="lod-ld__title">' + A.esc(it.t) + '</h3>' +
          '<p class="lod-ld__meta"><span>' + A.esc(it.m) + '</span> <b class="lod-ld__now">' + A.money(it.p) + '</b>' +
          (it.c > it.p ? ' <s>' + A.money(it.c) + '</s>' : '') + '</p>' +
          '<p class="lod-final">Final sale</p>' + // anh 10-15: everything in Last in the box (= ol-odd-lot) is final sale
          '<button type="button" class="lod-btn lod-btn--claim' + (mine ? ' is-added' : ' lod-btn--pulse') + '" data-ld-add data-hc-el="lightning-claim"' + (mine ? ' disabled' : '') + '>' +
            (mine ? '✓ In your cart · check out to keep it' : 'Claim · ' + A.money(it.p)) + '</button>' +
          '<div class="lod-ld__bar"><i data-ld-bar></i></div>' +
          '<p class="lod-ld__left" data-ld-left></p>' +
          '<div class="lod-next" data-ld-next></div>' + // inside info: below the photo on mobile, right column on desktop
        '</div>' +
      '</div>';
    box.querySelector('[data-ld-add]').addEventListener('click', function () {
      if (cur.gone) return;
      A.runAdd(this, it, { keep: true, addedText: '✓ In your cart · check out to keep it' }).then(function (ok) { if (ok) claimed[it.h] = true; });
    });
    renderNext(s);
    var nx = POOL[(s + 1) % POOL.length];
    if (nx) (new Image()).src = A.img(nx.i, 700);
    // live double-check: stale stock at first paint → skip silently; sold while on screen → GONE (via lod:data)
    fetch('/products/' + encodeURIComponent(it.h) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || p.available || cur.it !== it) return;
        if (Date.now() - cur.at < 2500 && !claimed[it.h]) { A.markGone(it.h); shownSlot = null; tick(); } else A.markGone(it.h);
      }).catch(function () {});
  }

  function renderNext(s) {
    var row = box.querySelector('[data-ld-next]');
    var items = [];
    for (var k = 1; k <= 4 && k < POOL.length; k++) items.push(POOL[(s + k) % POOL.length]);
    row.hidden = !items.length;
    row.innerHTML = items.length ? '<p class="lod-next__h">Up next</p><div class="lod-next__row">' + items.map(function (it, k) {
      var off = A.pct(it.p, it.c);
      // NOT tappable (DD ruling 09-25: photo + time + % only — buying before the slot kills the appear-then-leave FOMO).
      // Tagged only to measure taps (Afroyla 10-14: ~200 untagged rage clicks, Up-next suspected).
      return '<div class="lod-next__item" data-hc-el="lightning-up-next"><div class="lod-next__img"><img src="' + A.esc(A.img(it.i, 240)) + '" alt="" loading="lazy" width="240" height="240">' +
        (off ? '<span class="lod-next__off">−' + off + '%</span>' : '') + '</div><span data-next-k="' + k + '"></span></div>';
    }).join('') + '</div>' : '';
  }

  function goneState() {
    if (!cur || cur.gone || claimed[cur.it.h]) return;
    cur.gone = true;
    box.querySelector('.lod-ld__card').classList.add('is-gone');
    var btn = box.querySelector('[data-ld-add]');
    btn.disabled = true; btn.classList.remove('lod-btn--pulse'); btn.textContent = 'Someone just took the last one.';
  }

  function timers() {
    var remain = endsAt() - A.now();
    var left = box.querySelector('[data-ld-left]');
    if (left) left.innerHTML = cur && cur.gone ? 'Next one in <b>' + A.mss(remain) + '</b>' : 'Leaves the screen in <b>' + A.mss(remain) + '</b>';
    var bar = box.querySelector('[data-ld-bar]');
    if (bar) bar.style.width = Math.max(0, Math.min(100, remain / SLOT * 100)) + '%';
    box.querySelectorAll('[data-next-k]').forEach(function (el) { el.textContent = 'in ' + A.mss(remain + Number(el.dataset.nextK) * SLOT); });
  }

  root.addEventListener('lod:data', function () {
    setPool();
    if (cur) {
      var live = A.data().filter(function (d) { return d.h === cur.it.h; })[0];
      if (live && !live.a) goneState();
    }
    if (!POOL.length) tick();
  });
  root.addEventListener('lod:ended', function () { wrap.hidden = true; });
  tick();
  setInterval(tick, 250);
})();
